// src/Login.js
import React, { useState } from "react";
import { auth } from "./firebase";
import { signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import logo from "./optolog_logo.png";
import { useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "./firebase";


function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    try {
      await signInWithEmailAndPassword(auth, email, password);
      const userRef = doc(db, "users", auth.currentUser.email);
const userSnap = await getDoc(userRef);

if (userSnap.exists()) {
  const role = userSnap.data().role;

  if (role === "student") navigate("/student-dashboard");
  else if (role === "faculty") navigate("/faculty-dashboard");
  else if (role === "admin") navigate("/admin-dashboard");
  else navigate("/login"); // fallback if role is missing
} else {
  console.error("User role not found in Firestore");
  navigate("/login");
}
    } catch (err) {
      console.error(err);
      setError("Incorrect email or password.");
    }
  };

  const handleForgotPassword = async () => {
    setError("");
    setSuccess("");
    if (!email) return setError("Please enter your email first.");
    try {
      await sendPasswordResetEmail(auth, email);
      setSuccess("Password reset email sent. Check your inbox!");
    } catch (err) {
      console.error(err);
      setError("Error sending password reset email. Check the email address.");
    }
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.container}>
        <img src={logo} alt="OptoLog Logo" style={styles.logo} />
        <h2 style={styles.title}>Welcome Back</h2>

        <form onSubmit={handleLogin} style={styles.form}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={styles.input}
            required
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
            required
          />

          <button type="submit" style={styles.button}>Log In</button>
        </form>

        <p onClick={handleForgotPassword} style={styles.forgotPassword}>Forgot Password?</p>

        {error && <p style={styles.error}>{error}</p>}
        {success && <p style={styles.success}>{success}</p>}
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#20466b",
    fontFamily: "'Poppins', sans-serif",
    padding: "20px",
  },
  container: {
    backgroundColor: "#ffffff",
    padding: "40px 20px",
    borderRadius: "16px",
    boxShadow: "0 6px 18px rgba(0, 0, 0, 0.3)",
    maxWidth: "400px",
    width: "100%",
    textAlign: "center",
  },
  logo: {
    width: "50%",
    maxWidth: "140px",
    marginBottom: "20px",
  },
  title: {
    marginBottom: "20px",
    color: "#20466b",
    fontSize: "24px",
    fontWeight: "600",
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  input: {
    padding: "12px",
    marginBottom: "16px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    fontSize: "14px",
    width: "100%",
    boxSizing: "border-box",
  },
  button: {
    padding: "14px",
    fontSize: "16px",
    backgroundColor: "#00ffca",
    color: "#20466b",
    border: "none",
    borderRadius: "10px",
    cursor: "pointer",
    fontWeight: "bold",
    transition: "background-color 0.3s",
  },
  forgotPassword: {
    marginTop: "12px",
    color: "#20466b",
    cursor: "pointer",
    fontSize: "14px",
    textDecoration: "underline",
  },
  error: {
    marginTop: "16px",
    color: "red",
    fontSize: "14px",
  },
  success: {
    marginTop: "16px",
    color: "#00cc88",
    fontSize: "14px",
    fontWeight: "bold",
  },
};

export default Login;
